<template>
  <div>
    <v-divider />
    <v-row class="d-flex justify-sm-end">
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="primary"
          outlined
          :to="`/manage/forms/${moderatedOperation.object_type}/${moderatedOperation.form_name}/${moderatedOperation.id}`"
          >{{ $t("button.see.originalForm") }}</v-btn
        >
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="purple"
          outlined
          v-if="moderatedOperation.object_id"
          :to="`/manage/edit/researchers/edit/${moderatedOperation.object_id}`"
          >{{ $t("button.see.editObject") }}</v-btn
        >
      </v-col>
      <v-spacer />
      <v-col cols="6" sm="3" md="2" class="d-flex justify-center">
        <FinishFormSwitch :item="moderatedOperation" />
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2">
        <ProcessingCommentDialog :moderated-operation="moderatedOperation" />
      </v-col>
    </v-row>
    <v-card class="pa-2" min-height="200">
      <v-overlay absolute :opacity="0" :value="!(moderatedOperation.data !== undefined && namePersons.length > 0)">
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>
      <AssignListRelationField
        :state="moderatedOperation.state"
        field="incharge"
        :data-mod-op="moderatedOperation.data"
        v-if="moderatedOperation.data !== undefined && namePersons.length > 0"
        :items-fromdb="namePersons"
        items-fromdb-text="name"
        :original_items="moderatedOperation.data.user.person.incharge"
      />
    </v-card>
    <v-divider />
    <ProcessFormActions :item="moderatedOperation" @item-processed="handleItemProcessed" />
  </div>
</template>

<script>
import ProcessFormActions from "../../action_buttons/ProcessFormActions";
import AssignListRelationField from "../../reusables/AssignInChargeInvestigators";
import ProcessingCommentDialog from "../../reusables/ProcessingCommentDialog";
import axios from "axios";
import FinishFormSwitch from "../../reusables/FinishFormSwitch";
import publication_model from "../../../mixins/model_utils/publication_model";
export default {
  name: "ProcessInvestigator",
  mixins: [publication_model],
  components: {
    FinishFormSwitch,
    ProcessFormActions,
    AssignListRelationField,
    ProcessingCommentDialog
  },

  data: () => ({
    moderatedOperation: {},
    comments: []
  }),

  created() {
    this.getNamePersons();
    this.getData();
  },
  methods: {
    handleItemProcessed(item){
      this.moderatedOperation.state = item.state;
      this.moderatedOperation.object_id = item.object_id;
    },
    getData() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/investigator/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.moderatedOperation = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
